import { AttributeNamesResponseDto } from 'api/useAnalyticsAttributeNames';
import { AttributeValuesResponseDto } from 'api/useAnalyticsAttributeValues';

export const formatAttributeNameOptions = (
  attributeNamesData?: AttributeNamesResponseDto
) => {
  return (
    attributeNamesData?.attributeNames.map((name: string) => ({
      label: name,
      value: name
    })) || []
  );
};

export const formatAttributeValueOptions = (
  selectedAttributeNames: string[],
  attributeValuesData?: AttributeValuesResponseDto,
  isLoading?: boolean
) => {
  const options: { label: string; value: string; disabled?: boolean; groupHeading?: string }[] = [];
  const valueMap = new Map<string, { name: string; value: string }>();

  if (selectedAttributeNames.length > 0 && attributeValuesData?.values) {
    for (const name of selectedAttributeNames) {
      const values = attributeValuesData.values[name] || [];
      values.forEach((value) => {
        const compositeValue = `${name}: ${value}`;
        options.push({
          label: value,
          value: compositeValue,
          disabled: isLoading,
          groupHeading: name
        });
        valueMap.set(compositeValue, { name, value });
      });
    }
  }

  return { attributeValueOptions: options, attributeValueMap: valueMap };
};

export const buildAttributeFilters = (
  selectedAttributeValues: string[],
  attributeValueMap: Map<string, { name: string; value: string }>
) => {
  const filters: Record<string, string[]> = {};
  selectedAttributeValues.forEach((compositeValue) => {
    const mappedValue = attributeValueMap.get(compositeValue);
    if (mappedValue) {
      const { name, value } = mappedValue;
      if (!filters[name]) {
        filters[name] = [];
      }
      filters[name].push(value);
    }
  });
  return filters;
}; 